<script>
import { platelistComputed } from '@state/helpers';

export default {
  components: {},
  props: {
    dayHasContent: {
      type: Boolean,
      required: false,
    },
    copyingDay: {
      type: Boolean,
      required: false,
    },
    isCopyingMeal: {
      type: Boolean,
      required: false,
    },
    isAddingDishDisabled: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...platelistComputed,
  },
  mounted() {},
  methods: {
    duplicateDayEnd() {
      this.$emit('duplicate-day-end');
    },
    applyMeal() {
      this.$emit('apply-meal');
    },
    handleClick() {
      if (!this.isSavingDish) {
        if (this.isCopyingMeal || this.isAddingDish) {
          if (!this.isAddingDishDisabled) {
            this.applyMeal();
          }
        } else {
          this.duplicateDayEnd();
        }
      }
    },
  },
};
</script>

<template>
  <div
    @click="handleClick"
    :class="[
      'copy-here-wrapper',
      {
        light: dayHasContent,
        disabled: isAddingDishDisabled,
        'saving-dish': isSavingDish,
      },
    ]"
  >
    <div class="copy-here">
      <span
        v-if="(!copyingDay && !isSavingDish) || isCopyingMeal || isAddingDish"
      >
        <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-copy'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
        <span v-if="isAddingDish">
          <span class="disabled-text" v-if="isAddingDishDisabled"
            >Not Cooked Yet</span
          >
          <span v-else>Add Meal</span>
        </span>
        <span v-if="copyingDay || isCopyingMeal">Copy Here</span>
      </span>
      <span
        v-if="copyingDay && !isCopyingMeal && !isAddingDish && !isSavingDish"
      >
        <BaseIcon name="sync" spin class="icon"> </BaseIcon>Duplicating...
      </span>
      <BaseLoadingSpinner v-if="isSavingDish" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.copy-here-wrapper {
  align-self: center;
  background-color: $color-light-gray-seventeen;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: center;
  justify-self: center;
  left: 7.5%;
  position: absolute;
  width: 85%;
  z-index: 1;

  .copy-here {
    @include calc-font-size(0.8);

    align-items: center;
    background-color: $color-light-gray-eighteen;
    border-radius: 50%;
    bottom: auto;
    color: $color-primary;
    display: flex;
    flex-direction: column;
    font-weight: bold;
    height: 80%;
    justify-content: center;
    letter-spacing: 0.116667px;
    line-height: 1.9rem;
    margin: auto auto;
    top: auto;
    width: 80%;

    span {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .icon {
        width: 300px;
      }
    }

    .icon-copy {
      margin-bottom: 0.5rem;
    }

    .loading {
      width: 3.5rem;
    }
  }

  &.light {
    background-color: rgba($color-white-wo-rgb, 0.55);
    left: 7.5%;
    position: absolute;
    right: 0;

    .copy-here {
      background-color: white;

      .icon-copy {
        path {
          fill: black;
        }
      }
    }
  }

  &.disabled {
    background-color: $color-light-gray;
    cursor: not-allowed;

    .copy-here {
      background-color: $color-medium-gray;

      .icon-copy {
        path {
          fill: $color-dark-gray;
        }
      }

      .disabled-text {
        color: $color-dark-gray;
      }
    }
  }

  &.saving-dish {
    cursor: not-allowed;
  }
}
</style>
